import { baseApi } from "configs/store-query";
import {
  SigninUserAuthApiRequest,
  SigninUserAuthApiResponse,
  SignupUserAuthApiRequest,
  SignupUserAuthApiResponse,
  SsoUserAuthApiRequest,
  SsoUserAuthApiResponse,
  SendUserAuthVerificationApiRequest,
  SendUserAuthVerificationApiResponse,
  VerifyUserAuthVerificationApiRequest,
  VerifyUserAuthVerificationApiResponse,
} from "apis/user/types/user-auth-api";

const BASE_PATH = "/users/auth";

export const userAuthController = baseApi.injectEndpoints({
  endpoints: (build) => ({
    signinUserAuth: build.mutation<
      SigninUserAuthApiResponse,
      SigninUserAuthApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/signin`,
        method: "POST",
        ...config,
      }),
    }),
    signupUserAuth: build.mutation<
      SignupUserAuthApiResponse,
      SignupUserAuthApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/signup`,
        method: "POST",
        ...config,
      }),
    }),
    verifyUserAuthEmailAddressVerification: build.mutation<
      VerifyUserAuthVerificationApiResponse,
      VerifyUserAuthVerificationApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/email-address/verification/verify`,
        method: "POST",
        ...config,
      }),
    }),
    sendUserAuthEmailAddressVerification: build.mutation<
      SendUserAuthVerificationApiResponse,
      SendUserAuthVerificationApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/email-address/verification/send`,
        method: "POST",
        ...config,
      }),
    }),
    ssoUserAuth: build.mutation<SsoUserAuthApiResponse, SsoUserAuthApiRequest>({
      query: (config) => ({
        url: `${BASE_PATH}/sso`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});
